import { useState } from "react";
import { uploadPermitExcel, downloadPermitTemplate } from "../../api/permit";
import { Loader2, Upload, FileDown } from "lucide-react";

/**
 * MobileExcelUpload
 * - 모바일 전용 엑셀 업로드 컴포넌트
 * - UI 모바일 대응
 */
export default function MobileExcelUpload({ onUploaded }) {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleUpload = async () => {
    if (!file) return alert("엑셀 파일을 선택하세요.");
    const formData = new FormData();
    formData.append("file", file);

    try {
      setLoading(true);
      const res = await uploadPermitExcel(formData);
      alert(res.data.message);
      onUploaded?.();
      setFile(null);
    } catch (err) {
      alert("업로드 실패: " + (err.response?.data?.error || err.message));
    } finally {
      setLoading(false);
    }
  };

  const handleDownload = async () => {
    try {
      const res = await downloadPermitTemplate();
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "인허가_일괄_등록.xlsx");
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (err) {
      alert("다운로드 실패: " + (err.response?.data?.error || err.message));
    }
  };

  return (
    <div className="rounded-lg border bg-white p-3 shadow-sm text-sm min-w-0 box-border w-full max-w-full overflow-hidden">
      <div className="flex flex-wrap items-center gap-2 mb-3 min-w-0 box-border">
        <h3 className="font-semibold text-gray-800 flex-shrink-0 text-xs">인허가 엑셀 업로드</h3>
        <button
          onClick={handleDownload}
          className="flex items-center gap-1 rounded-md px-2 py-1 hover:bg-gray-100 text-gray-700 transition flex-shrink-0 whitespace-nowrap text-xs"
        >
          <FileDown size={12} />
          템플릿
        </button>
      </div>

      <div className="flex flex-nowrap items-center gap-2 min-w-0 box-border">
        {/* 파일 선택 */}
        <label className="cursor-pointer flex items-center gap-1.5 rounded-md border border-dashed border-gray-300 bg-gray-50 px-2 py-1.5 text-gray-600 hover:border-indigo-400 hover:bg-indigo-50 transition flex-1 min-w-0 box-border">
          <input
            type="file"
            accept=".xlsx,.xls"
            onChange={(e) => setFile(e.target.files[0])}
            className="hidden"
          />
          <span className="truncate min-w-0 flex-1 text-xs">{file ? file.name : "파일 선택"}</span>
        </label>

        {/* 업로드 버튼 */}
        <button
          onClick={handleUpload}
          disabled={loading}
          className="flex items-center gap-1 rounded-md px-2.5 py-1.5 border hover:bg-gray-400 text-xs font-medium disabled:opacity-60 transition flex-shrink-0 whitespace-nowrap"
        >
          {loading ? (
            <>
              <Loader2 size={12} className="animate-spin" />
              <span className="text-[10px]">업로드 중...</span>
            </>
          ) : (
            <>
              <Upload size={12} />
              <span className="text-xs">업로드</span>
            </>
          )}
        </button>
      </div>

      <p className="mt-2 text-[10px] text-gray-500 break-words min-w-0">
        ※ 템플릿 양식에 맞춰 작성된 파일(.xlsx)만 업로드 가능합니다.
      </p>
    </div>
  );
}

